import { useState, useCallback, useRef } from 'react'
import { useSelector } from 'react-redux'
import { pdfGenerationSelector } from '../../../../modules/selectors/app'

// Custom hook to manage chart export state (PDF or PNG)
// Centralizes export mode detection for charts that need special rendering during export
export const useChartExportMode = () => {
  const [isPngExporting, setIsPngExporting] = useState(false)
  const isPdfGenerating = useSelector(pdfGenerationSelector)

  // Stores the Promise resolve callback from exportChartAsPng
  const chartReadyCallbackRef = useRef(null)

  // Called by exportChartAsPng to start export
  // chartReadyCallback is optional - only provided for charts that need async rendering
  const onExportStart = useCallback(chartReadyCallback => {
    if (chartReadyCallback) {
      chartReadyCallbackRef.current = chartReadyCallback
    }
    setIsPngExporting(true)
  }, [])

  const onExportEnd = useCallback(() => {
    chartReadyCallbackRef.current = null
    setIsPngExporting(false)
  }, [])

  // Called by chart when rendering is complete - resolves the Promise in exportChartAsPng
  const onChartReady = useCallback(() => {
    if (chartReadyCallbackRef.current) {
      chartReadyCallbackRef.current()
    }
  }, [])

  return {
    isExporting: isPdfGenerating || isPngExporting,
    isPdfGenerating,
    isPngExporting,
    onExportStart,
    onExportEnd,
    onChartReady
  }
}
